import React, { FunctionComponent } from 'react';
import { StyleProp, StyleSheet, TouchableOpacity, View, ViewStyle } from 'react-native';
import Icon from 'react-native-vector-icons/dist/FontAwesome';
import Theme from '../../../theme';
import { defaultScale } from '../../../utils/scaling';

interface IProps {
  disabled: boolean;
  icon: string;
  svgIcon?: React.ReactNode;
  active?: boolean;
  onPress: () => void;
  size?: number | void;
  style?: StyleProp<ViewStyle>;
  children?: React.ReactNode;
}

export const MediaControlButton: FunctionComponent<IProps> = ({
                                                                icon,
                                                                disabled,
                                                                active = false,
                                                                onPress,
                                                                size = defaultScale(50),
                                                                style,
                                                                svgIcon,
                                                                children,
                                                              }) => {

  const iconColor = () => {
    if (active) {
      return Theme.WHITE;
    } else if (disabled) {
      return Theme.GREY;
    }
    return Theme.PRIMARY;
  };

  return (
    <TouchableOpacity disabled={disabled} onPress={onPress} style={style}>
      <View
        style={[
          styles.mediaButton,
          !children && [styles.mediaButtonBorder, { borderColor: Theme.PRIMARY }],
          disabled && styles.mediaButtonDisabled,
          active && { backgroundColor: Theme.PRIMARY },
          disabled && active && styles.activeDisabled,
          { height: size, width: size },
        ]}
      >
        {
          children
            ?
            children
            :
            <Icon name={icon} size={size / 2} color={iconColor()}/>
        }
      </View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  mediaButton: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    width: defaultScale(50),
    height: defaultScale(50),
    marginHorizontal: defaultScale(6),
  },
  mediaButtonBorder: {
    borderRadius: 1000,
    borderWidth: 2,
  },
  activeDisabled: {
    backgroundColor: Theme.GREY,
  },
  mediaButtonActiveDisabled: {
    backgroundColor: Theme.GREY,
    borderColor: Theme.GREY,
  },
  mediaButtonDisabled: {
    borderColor: Theme.GREY,
  },
});
